var _circle, _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 198,
    viewBox: "0 0 246 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 123.495,
    cy: 99.0007,
    r: 98.4948,
    fill: "#ECECEE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6511_14678)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 27,
    width: 187.501,
    height: 115.158,
    rx: 2.95277,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6511_14678)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 56.207,
    width: 187.501,
    height: 115.158,
    rx: 2.95277,
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_6511_14678)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 39,
    width: 221,
    height: 120,
    rx: 3.48032,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.7205,
    y: 45.9609,
    width: 63.5158,
    height: 6.5256,
    rx: 1.74016,
    fill: "#ECECEE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.4862,
    height: 6.5256,
    rx: 3.2628,
    transform: "matrix(-1 0 0 1 98.2029 45.9609)",
    fill: "#ECECEE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 63.5158,
    height: 6.5256,
    rx: 1.74016,
    transform: "matrix(-1 0 0 1 81.2363 54.2266)",
    fill: "#ECECEE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 50.0296,
    height: 15.6614,
    rx: 1.74016,
    transform: "matrix(-1 0 0 1 67.75 64.2324)",
    fill: "#ECECEE"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_6511_14678)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 81.6713,
    cy: 71.193,
    r: 8.7008,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8627 67.1289C74.8807 68.5324 74.44 70.244 74.6221 71.9472C74.8042 73.6505 75.5969 75.2302 76.8535 76.3943C78.1101 77.5584 79.7458 78.2281 81.4579 78.2797C83.1701 78.3313 84.8431 77.7612 86.1675 76.6749C87.492 75.5885 88.3783 74.0594 88.6626 72.3702C88.947 70.681 88.6101 68.946 87.7143 67.4859C86.8185 66.0258 85.4243 64.9395 83.7896 64.4277C82.1549 63.9159 80.3902 64.0133 78.8217 64.7018L81.6714 71.1934L75.8627 67.1289Z",
    fill: "#ECECEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.004 64.1115C80.7298 64.0517 79.463 64.3368 78.3372 64.9368C77.2115 65.5367 76.2685 66.4293 75.6076 67.5205L81.6716 71.1932L82.004 64.1115Z",
    fill: "#F7F8FA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M219.537 51.6596C220.235 51.6596 220.8 52.2245 220.8 52.9227C220.8 53.6208 220.235 54.1857 219.537 54.1857C218.839 54.1857 218.274 53.6208 218.274 52.9227C218.274 52.2245 218.839 51.6596 219.537 51.6596ZM218.274 49.8353C218.274 50.5335 218.839 51.0983 219.537 51.0983C220.235 51.0983 220.8 50.5335 220.8 49.8353C220.8 49.1371 220.235 48.5723 219.537 48.5723C218.839 48.5723 218.274 49.1371 218.274 49.8353ZM218.274 56.01C218.274 56.7082 218.839 57.2731 219.537 57.2731C220.235 57.2731 220.8 56.7082 220.8 56.01C220.8 55.3119 220.235 54.747 219.537 54.747C218.839 54.747 218.274 55.3119 218.274 56.01Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6511_14678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7205 172.52V151.704L52.4764 129.236L87.4687 117.011L121.988 100.16L156.508 117.672L190.318 109.742L235.24 178.467L190.791 172.52H17.7205Z",
    fill: "#ECECEE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6511_14678",
    x: 18.2982,
    y: 19.5322,
    width: 209.905,
    height: 137.562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.73392
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.60088
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6511_14678"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6511_14678",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6511_14678",
    x: 18.2982,
    y: 48.7392,
    width: 209.905,
    height: 137.562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.73392
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.60088
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6511_14678"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6511_14678",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_6511_14678",
    x: 0.5,
    y: 31,
    width: 245,
    height: 144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6511_14678"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6511_14678",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_6511_14678",
    x: 69.1034,
    y: 59.9142,
    width: 25.1357,
    height: 25.1364,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.28901
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.93351
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6511_14678"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6511_14678",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6511_14678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 211,
    height: 55,
    fill: "white",
    transform: "translate(17.7205 96.6797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDashboard);
export default __webpack_public_path__ + "static/media/empty-dashboard.03aa88778ef93453b439d9d004e9bcc4.svg";
export { ForwardRef as ReactComponent };